import React, { useState, useContext, Suspense } from 'react';
import DynamicLayout from '../components/DynamicLayout';
import { PlatformContext } from '../context/PlatformContext';
import { MobileComponents, DesktopComponents, LoadingComponent } from '../helpers/platformUtils';
import TransitDashboard from '../components/tools/TransitDashboard';

const TransitsPage = () => {
  const { platform, loading } = useContext(PlatformContext);
  
  if (loading) {
    return (
      <DynamicLayout>
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const isMobile = platform === 'mobileApp' || platform === 'mobileWeb';

  return (
    <DynamicLayout>
      <Suspense fallback={<LoadingComponent />}>
        <TransitDashboard isMobile={isMobile} />
      </Suspense>
    </DynamicLayout>
  );
};

export default TransitsPage;
